export enum PriorityName {
    LEFT = 'left',
    RIGHT = 'right',
}
